import { render, staticRenderFns } from "./UserProfileNavigation.vue?vue&type=template&id=3b2ca03c&scoped=true&"
import script from "./UserProfileNavigation.vue?vue&type=script&lang=js&"
export * from "./UserProfileNavigation.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileNavigation.vue?vue&type=style&index=0&id=3b2ca03c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2ca03c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VFlex,VFooter,VIcon,VLayout,VList,VMenu})
